<mat-accordion>

    <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Público Alvo - Planejamento Oficina: {{planejamentoOficina.descricao}}
            </mat-panel-title>
        </mat-expansion-panel-header>

        <cadastrar-publico-alvo-planejamento-oficina #cadastrarPublicoAlvoPlanejamentoOficina [planejamentoOficina]="planejamentoOficina"
                         [perfilAcesso]="perfilAcesso">
        </cadastrar-publico-alvo-planejamento-oficina>
    </mat-expansion-panel>


    <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="listarPublicosAlvosPlanejamentoOficina.carregarLista()"
                         (closed)="openFormCadastro = true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Lista de Público Alvo ( {{ planejamentoOficina.publicosAlvosPlanejamentoOficina?.length }} )
            </mat-panel-title>
        </mat-expansion-panel-header>

        <listar-publico-alvo-planejamento-oficina #listarPublicosAlvosPlanejamentoOficina
                      [publicosAlvosPlanejamentoOficina]="planejamentoOficina.publicosAlvosPlanejamentoOficina"
                      (onAtualizarPublicoAlvoPlanejamentoOficina)="onGetAdicionar($event); cadastrarPublicoAlvoPlanejamentoOficina.atualizarPublicoAlvoPlanejamentoOficina($event)"
                      (onAdicionarPublicoAlvoPlanejamentoOficina)="onGetAdicionar($event); cadastrarPublicoAlvoPlanejamentoOficina.cancelar()">
        </listar-publico-alvo-planejamento-oficina>
    </mat-expansion-panel>
</mat-accordion>
